var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"srcdoc":_vm.paymentProcessHtml}})])
}
var staticRenderFns = []

export { render, staticRenderFns }